import URLConfig from '@Config/urls/url.config';
import { Route } from 'react-router-dom';
import * as SmartModule from '@Modules/cardManagementSystem/smart/pages';
import React from 'react';

const URL_GLOBAL_PARAMETERS = URLConfig.CARD_MANAGEMENT_SYSTEM.CARDSMARTHOLDER.GLOBAL_PARAMETERS
const URL_SCRIPT_PROCESSING = URLConfig.CARD_MANAGEMENT_SYSTEM.CARDSMARTHOLDER.SCRIPT_PROCESSING;
const URL_BATCHES = URLConfig.CARD_MANAGEMENT_SYSTEM.CARDSMARTHOLDER.BATCHES;

const SmartRoutes = [
  // Global Parameters MENU ROUTES
  <Route>
    {globalParametersMenuRoutes().map((oneRoute, index) => (
      <React.Fragment key={index}>{oneRoute}</React.Fragment>
    ))}
  </Route>,
  // Script Processing  MENU ROUTES
  <Route>
    {scriptProcessingMenuRoutes().map((oneRoute, index) => (
      <React.Fragment key={index}>{oneRoute}</React.Fragment>
    ))}
  </Route>,
  // Batches Route
  <Route>
    {batchesMenuRoutes().map((oneRoute, index) => (
      <React.Fragment key={index}>{oneRoute}</React.Fragment>
    ))}
  </Route>,
  
  
];

function globalParametersMenuRoutes() {
  return [
    <Route
      path={URL_GLOBAL_PARAMETERS.PROFILE_APPLICATION}
      element={<SmartModule.ProfileApplication />}
    />,
    <Route
      path={URL_GLOBAL_PARAMETERS.PARAMETERS_SCRIPT_PROCESSING}
      element={<SmartModule.ScriptProcessingParameters />}
    />,
  ];
}

function scriptProcessingMenuRoutes() {
  return [
    <Route
      path={URL_SCRIPT_PROCESSING.RULES}
      element={<SmartModule.Rules />}
    />,
    <Route
      path={URL_SCRIPT_PROCESSING.CONSULTATION}
      element={<SmartModule.Consultation />}
    />,
    <Route
      path={URL_SCRIPT_PROCESSING.ORDER + ':id/'}
      element={<SmartModule.Orders />}
    />,
    <Route
      path={URL_SCRIPT_PROCESSING.CARD_UPDATE}
      element={<SmartModule.CardUpdate />}
    />,
    <Route
      path={URL_SCRIPT_PROCESSING.CARD_UPDATE_PER_BIN}
      element={<SmartModule.CardUpdatePerBIN />}
    />,
    
  ];
}

function batchesMenuRoutes() {
  return [
    // Batches Menu Routes
    <Route
      path={URL_BATCHES.BATCHES_MONITORING}
      element={<SmartModule.BatchesMonitoringPage />}
    />,
    <Route
      path={URL_BATCHES.BATCHES_ERRORS}
      element={<SmartModule.BatchErrorsPage />}
    />,
    <Route
      path={URL_BATCHES.BATCHES_TRACES}
      element={<SmartModule.BatchesTracksPage />}
    />,
  ];
}


export default SmartRoutes;
